import React, {useContext} from "react"
import {useTranslation} from "react-i18next";
import {useKeycloak} from "@react-keycloak/web";
import {UserContext} from "../../context/UserContext"
import {NavLink, useNavigate} from "react-router-dom";

const TopBar = () => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const onAsideToggle = (event) => {
    event.currentTarget.classList.toggle("is-active");
    document.documentElement.classList.toggle('has-aside-mobile-expanded')
  }

  const onNavBarMenuToggle = (event) => {
    event.currentTarget.classList.toggle("is-active");
    document.getElementById("navbar-menu").classList.toggle('is-active')
  }

  const {t} = useTranslation();
  const keycloakInstance = useKeycloak();

  function onLogInButton() {
    keycloakInstance.keycloak.login();
  }

  function onRegisterButton() {
    navigate("/register");
  }

  function onLogOutButton() {
    keycloakInstance.keycloak.logout();
  }

  return (
    <nav className="navbar is-fixed-top" >
      <div className="navbar-brand">
        <a className="navbar-burger is-left" onClick={onAsideToggle}>
          <span aria-hidden="true"/>
          <span aria-hidden="true"/>
          <span aria-hidden="true"/>
        </a>
        <div className="navbar-item">

        </div>
        <a className="navbar-dots" onClick={onNavBarMenuToggle}>
          <span aria-hidden="true"/>
          <span aria-hidden="true"/>
          <span aria-hidden="true"/>
        </a>
      </div>

      <div id="navbar-menu" className="navbar-menu">
        <div className="navbar-end">
          <div className="navbar-item has-dropdown is-hoverable">
            
            {user?.id ? (<>
            <a className="navbar-link is-arrowless ">
              <span className="fz fz-user vertically-centered larger"/>
              <span className="has-padding-right-10 has-padding-left-10">Welcome, {user.firstName}!</span>
              <span className="fz fz-chevron-down small solid is-hidden-touch"/>
            </a>
            <div className="navbar-dropdown is-paddingless">
              <NavLink to="/profile" className="navbar-item">
                <span className="fz fz-user solid"/>
                <span className="has-padding-left-10">{t("my_profile")}</span>
              </NavLink>
              <a className="navbar-item" onClick={onLogOutButton}>
                <span className="fz fz-sign-out-alt solid"/>
                <span className="has-padding-left-10">{t("logout")}</span>
              </a>
            </div>
            </>) : (<>
            <a className="navbar-link is-arrowless ">
              <span className="fz fz-user vertically-centered larger"/>
              <span className="has-padding-right-10 has-padding-left-10">Login/Register</span>
              <span className="fz fz-chevron-down small solid is-hidden-touch"/>
            </a>
            <div className="navbar-dropdown is-paddingless">
              <a className="navbar-item" onClick={onLogInButton}>
                <span className="fz fz-user solid"/>
                <span className="has-padding-left-10">{t("login")}</span>
              </a>
              <a className="navbar-item" onClick={onRegisterButton}>
                <span className="fz fz-sign-out-alt solid"/>
                <span className="has-padding-left-10">{t("register")}</span>
              </a>
            </div>
            </>)}
          
          </div>
        </div>
      </div>
    </nav>
  )
}

export default TopBar
